import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import {LoginDetailsReducer} from './auth/reducer';
import {projectCode} from "../constants/defaultValues";
import storage from "redux-persist/lib/storage";
import {persistReducer} from "redux-persist";

const reducers = combineReducers({
  menu,
  settings,
  LoginDetails: LoginDetailsReducer
});

const persistConfig = {
  key: projectCode,
  storage,
};

export default persistReducer(persistConfig, reducers);
